import styled, { keyframes } from 'styled-components'

const attentionPulse = keyframes`
  0%   { box-shadow: 0 0 0 0 rgba(56, 125, 255, 0.45); }
  70%  { box-shadow: 0 0 0 8px rgba(56, 125, 255, 0); }
  100% { box-shadow: 0 0 0 0 rgba(56, 125, 255, 0); }
`

// TODO: remove when canvas text editing is enabled
export const PulseWrapper = styled.div`
  border-radius: 8px;
  animation: ${attentionPulse} 600ms ease-out 2;
`
